import { useEffect } from 'react'
import { Button, Drawer, Input, useDrawer } from '@iveco-ti/iveco-ds'
import { FormProvider, useForm } from '@iveco-ti/iveco-ds/hook-form'
import { useTranslation } from 'react-i18next'

import { useRemoveGenericContent } from '../hooks/useRemoveGenericContent'
import { useSelectedGenericContentStore } from '../stores/useSelectedGenericContentStore'

export function DrawerViewGenericContent() {
  const { t } = useTranslation(['settings', 'common'])
  const { close } = useDrawer('drawer-view-generic-content')
  const hookForm = useForm()
  const { genericContent, setGenericContent } = useSelectedGenericContentStore()
  const { handleRemoveGenericContent } = useRemoveGenericContent()

  const handleClose = () => {
    close()
    setGenericContent(null)
    hookForm.reset()
  }

  useEffect(() => {
    if (genericContent) {
      hookForm.reset({
        tagContent: genericContent.tagContent,
        fieldKey: genericContent.fieldKey,
        fieldValue: genericContent.fieldValue,
        contentType: genericContent.contentType?.join(', ') || '',
        relativeKeys: genericContent.relativeKeys?.join(', ') || '',
        searchTags: genericContent.searchTags?.join(', ') || '',
        infoMessage: genericContent.infoMessage,
      })
    }
  }, [genericContent, hookForm])

  return (
    <Drawer.Root id="drawer-view-generic-content">
      <Drawer.Header>
        <h1 className="text-lg text-brand-800 font-semibold">
          {t('generic_content.drawer_view_generic_content.header.title')}
        </h1>
      </Drawer.Header>

      <Drawer.Body>
        <h2 className="text-2xl font-semibold text-brand-700">
          {t('generic_content.drawer_view_generic_content.body.title')}
        </h2>

        <FormProvider {...hookForm}>
          <form className="space-y-6">
            <Input.Base
              disabled
              name="tagContent"
              label={t(
                'generic_content.drawer_view_generic_content.fields.tag_content.label',
              )}
            />

            <div className="flex gap-4">
              <div className="flex-1">
                <Input.Base
                  disabled
                  name="fieldKey"
                  label={t(
                    'generic_content.drawer_view_generic_content.fields.field_key.label',
                  )}
                />
              </div>

              <div className="flex-1">
                <Input.Base
                  disabled
                  name="fieldValue"
                  label={t(
                    'generic_content.drawer_view_generic_content.fields.field_value.label',
                  )}
                />
              </div>
            </div>

            <Input.Base
              disabled
              name="contentType"
              label={t(
                'generic_content.drawer_view_generic_content.fields.content_type.label',
              )}
            />

            <Input.Base
              disabled
              name="relativeKeys"
              label={t(
                'generic_content.drawer_view_generic_content.fields.relative_keys.label',
              )}
            />

            <Input.Base
              disabled
              name="searchTags"
              label={t(
                'generic_content.drawer_view_generic_content.fields.search_tags.label',
              )}
            />

            <Input.TextArea
              disabled
              name="infoMessage"
              label={t(
                'generic_content.drawer_view_generic_content.fields.info_message.label',
              )}
            />
          </form>
        </FormProvider>
      </Drawer.Body>

      <Drawer.Footer className="flex items-center justify-end gap-4">
        {genericContent && (
          <Button.Root
            variant="secondary"
            color="danger"
            onClick={() => handleRemoveGenericContent(genericContent.id)}
            className="mr-auto"
          >
            {t(
              'generic_content.drawer_view_generic_content.footer.remove_button.label',
            )}
          </Button.Root>
        )}

        <Button.Root variant="secondary" color="brand" onClick={handleClose}>
          {t(
            'generic_content.drawer_view_generic_content.footer.close_button.label',
          )}
        </Button.Root>
      </Drawer.Footer>
    </Drawer.Root>
  )
}
